import api from '../utils/api';

class CacheApi {
  reset() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/cache-reset');
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  }

  resetByType(types) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('v1/admin/admin/maintenance/cache-reset', {
          data_type: types,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  }
}

const cacheApi = new CacheApi();
export default cacheApi;
